import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import SEO from "../../components/site/SEO";

export default function PaymentCancel() {
  return (
    <>
      <SEO title="Booking not completed — Wonder Washers" description="Your booking was not completed." />
      <section className="max-w-2xl mx-auto py-24 px-6" data-testid="payment-cancel-page">
        <div className="ww-card-lg p-10 md:p-12 text-center">
          <XCircle className="mx-auto h-12 w-12 text-slate-400 mb-6" />
          <div className="text-xs font-subhead tracking-widest text-slate-500 uppercase mb-3">Cancelled</div>
          <h1 className="font-display uppercase text-4xl md:text-5xl text-[color:var(--ww-navy)] leading-none">No charge — your booking wasn't confirmed.</h1>
          <p className="mt-6 text-slate-600 leading-relaxed">
            You closed the payment window before it completed, so we didn't take a deposit. Your time slot isn't reserved yet — head back to the booking wizard to pick it back up.
          </p>
          <div className="mt-10 flex flex-wrap gap-3 justify-center">
            <Link to="/book" data-testid="payment-cancel-retry" className="ww-btn-primary">Try again</Link>
            <Link to="/" className="ww-btn-outline">Back home</Link>
          </div>
        </div>
      </section>
    </>
  );
}
